import * as _ from "lodash";
import {BaseModifyDashboardWidgetView, BaseModifyDashboardWidgetViewOptions} from "../_BaseModifyWidgetView";
var template = require('templates/modals/dashboard/modify_widgets/genericnooptions/genericnooptions.html');

export class ModifyNoOptionsWidgetView extends BaseModifyDashboardWidgetView {

    template = _.template(template);

    constructor(options: BaseModifyDashboardWidgetViewOptions) {
        super(<any> _.extend({
            tagName: "div",
            className: 'widget-type-generic-no-options',
            events: {}
        }, options));

        this.options.widget = new this.options.dashboardWidgetCollection.model({
            dashboard_id: this.options.dashboardId,
            params: [],
            dashboard_category_id: this.options.categoryId,
            type_id: this.options.widgetTypeId,
            order: this.getWidgetOrder()
        });
    }

    render() {
        this.$el.html(this.template({
            dashboardCategoriesCollection: this.options.dashboardCategoryCollection,
            dashboardTabCollection: this.options.dashboardTabCollection,
            widget: this.options.widget,
            tabId: this.options.tabId
        }));
        return this;
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/modals/dashboard/modify_widgets/genericnooptions/GenericNoOptions.ts